import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Contract2DiagnosesicherheitEntity } from '../../../entities/mdqx/contract2diagnosesicherheit.entity';
import {
    Contract2DiagnosesicherheitActions,
    Contract2DiagnosesicherheitActionTypes,
} from '../../actions/mdqx/contract2diagnosesicherheit.actions';

export interface Contract2DiagnosesicherheitState
    extends EntityState<Contract2DiagnosesicherheitEntity> {
    fetched: boolean;
}

export const CONTRACT2DIAGNOSESICHERHEIT_KEY = 'contract2Diagnosesicherheit';

const adapter = createEntityAdapter<Contract2DiagnosesicherheitEntity>({
    selectId: contract2Diagnosesicherheit => contract2Diagnosesicherheit.Id,
});

const initialState: Contract2DiagnosesicherheitState = adapter.getInitialState({
    fetched: false,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export function contract2DiagnosesicherheitReducer(
    state = initialState,
    action: Contract2DiagnosesicherheitActions,
) {
    switch (action.type) {
        case Contract2DiagnosesicherheitActionTypes.GetContract2DiagnosesicherheitenResponse: {
            return adapter.setAll(action.Payload, { ...state, fetched: true });
        }

        case Contract2DiagnosesicherheitActionTypes.PostContract2DiagnosesicherheitResponse: {
            return adapter.addOne(action.Payload, state);
        }

        case Contract2DiagnosesicherheitActionTypes.PatchContract2DiagnosesicherheitResponse: {
            return adapter.setOne(action.Payload, state);
        }

        case Contract2DiagnosesicherheitActionTypes.DeleteContract2DiagnosesicherheitResponse: {
            return adapter.removeOne(action.Payload, state);
        }

        default: {
            return state;
        }
    }
}

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectAll } = adapter.getSelectors();

export const selectAllContract2Diagnosesicherheiten = selectAll;

export const selectContract2DiagnosesicherheitenFetched = (
    state: Contract2DiagnosesicherheitState,
) => state.fetched;
